import { useState, type ReactNode } from "react";
import { cn } from "../../lib/utils.js";
import { contactGroupPreview } from "./contact-groups-preview.js";
import { contactsGroupMoreChipClass } from "./contacts-table-presentation.js";

export function CollapsibleChipList<T>({
  items,
  getKey,
  renderChip,
  moreLabel,
  showLessLabel,
  className,
  testId,
}: {
  items: readonly T[];
  getKey: (item: T) => string | number;
  renderChip: (item: T) => ReactNode;
  moreLabel: (remaining: number) => string;
  /** When set, an expanded list can collapse back to the preview. */
  showLessLabel?: string;
  className?: string;
  testId?: string;
}): React.JSX.Element {
  const [expanded, setExpanded] = useState(false);
  const preview = contactGroupPreview(items);
  const shown = expanded ? items : preview.visible;

  return (
    <div className={cn("flex min-w-0 max-w-full flex-wrap items-center gap-1", className)} data-testid={testId}>
      {shown.map((item) => (
        <span key={getKey(item)} className="contents">
          {renderChip(item)}
        </span>
      ))}
      {preview.remaining > 0 && !expanded ? (
        <button
          type="button"
          className={contactsGroupMoreChipClass}
          onClick={(event) => {
            event.stopPropagation();
            setExpanded(true);
          }}
          aria-expanded={false}
        >
          {moreLabel(preview.remaining)}
        </button>
      ) : null}
      {showLessLabel && expanded && preview.remaining > 0 ? (
        <button
          type="button"
          className={contactsGroupMoreChipClass}
          onClick={(event) => {
            event.stopPropagation();
            setExpanded(false);
          }}
          aria-expanded
        >
          {showLessLabel}
        </button>
      ) : null}
    </div>
  );
}
